import { httpsCallable } from "firebase/functions";
import { functions } from "../../../../config/firebaseConfig";

export const categorizeMaterial = async (material, showCategories = true) => {
  if (!showCategories) {
    console.log("Skipping AI categorization: categories disabled");
    return [];
  }

  try {
    const prompt = generatePrompt(material);
    const openAIProxy = httpsCallable(functions, "openAIProxy");
    const response = await openAIProxy({
      requestType: "chat",
      params: {
        model: "gpt-4o-mini",
        messages: [{ role: "user", content: prompt }],
        temperature: 0.7,
        max_tokens: 50,
      },
    });

    const categories = response.data.choices[0].message.content
      .split(",")
      .map((cat) => cat.trim())
      .slice(0, 3); // Limit to 3 categories

    return categories;
  } catch (error) {
    console.error("Error categorizing material:", error);
    return [];
  }
};

const generatePrompt = (material) => {
  // Return empty string if material type is neither questions nor audio-recorder
  if (material.type !== "questions" && material.type !== "audio-recorder") {
    return "";
  }

  // Handle special cases with predefined categories
  if (material.type === "audio-recorder") {
    return "speaking skills, pronunciation";
  }

  if (material.questionType === "Sentence Ordering") {
    return "grammar, syntax";
  }

  if (material.questionType === "Spell the Word") {
    return "grammar, spelling";
  }

  // For other question types, use AI categorization
  let prompt =
    "Try to understand what this question is assessing and define the most relevant category for the question from this list (separate your asnwer by commas): vocabulary, grammar, spelling, syntax, oral skills, reading comprehension, listening comprehension, cultural understanding, idioms and expressions. Do not give any explanation or reasoning, just the category name(s).\n\n";

  prompt += `Question type: ${material.questionType || material.type}\n`;
  prompt += `Question: ${material.question || ""}\n`;

  if (material.options) {
    prompt += `Options: ${material.options.join(", ")}\n`;
  }

  prompt +=
    "\nProvide only category names provided to you in the list, separated by commas.";
  return prompt;
};
